module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList15.c6833d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList15.png
// module id = 5CTe
// module chunks = 0